// Derive counts from stored observations; never invert the rounded 0–100 index.
export function weightedArticles(reading) {
  if (!reading || reading.score === null) return null;
  if (!Number.isFinite(reading.direct_articles) || !Number.isFinite(reading.context_articles)) return null;
  return reading.direct_articles + .25 * reading.context_articles;
}
export function segments(points) {
  // Connect observed readings visually; preserve missing data in storage/tooltips.
  const observed = points.filter(p => Number.isFinite(p.score));
  return observed.length ? [observed] : [];
}
export function enrichGame(game, now, source = 'news') {
  const isX=source==='x';
  const readingValue=p=>isX?(p?.score===null?null:Number.isInteger(p?.posts_24h)?p.posts_24h:null):weightedArticles(p);
  const points = (game.points || []).map(p => ({...p, score: readingValue(p)})).sort((a,b)=>Date.parse(a.at)-Date.parse(b.at));
  const valid = points.filter(p=>p.score!=null);
  const last = valid[valid.length-1];
  const count = readingValue(game.latest);
  const at = game.latest?.observed_at || last?.at;
  const ended = game.time_tbd
    ? game.kickoff_utc?.slice(0,10) <= new Date(now).toISOString().slice(0,10)
    : Date.parse(game.kickoff_utc) <= now;
  const delayed = game.latest?.status === 'unavailable' || (at && !ended && now-Date.parse(at)>(isX?(game.latest?.interval_minutes||360)+45:90)*60000);
  let change = null;
  if (last && !delayed) {
    const target = Date.parse(last.at)-86400000;
    // Require a reading at/before the target, within 45 minutes, not an arbitrary older reading.
    const prior = valid.filter(p=>Date.parse(p.at)<=target && target-Date.parse(p.at)<=45*60000).pop();
    if (prior && (isX || (!last.coverage_incomplete && !prior.coverage_incomplete))) change = last.score-prior.score;
  }
  if(isX)change=!delayed && Number.isInteger(game.latest?.change_24h)?game.latest.change_24h:null;
  return {...game, points, count, change, ended, delayed, observedAt:at, isX, gapMs:(isX?390:90)*60000};
}
export function sortGames(games, mode) {
  const metric = mode === 'increase' ? 'change' : 'count';
  return [...games].sort((a,b)=> {
    if(a[metric]==null && b[metric]!=null)return 1;
    if(b[metric]==null && a[metric]!=null)return -1;
    return (b[metric]??0)-(a[metric]??0) || (b.count??-1)-(a.count??-1) || a.id.localeCompare(b.id);
  });
}
